const { userStatus } = require('@transfeeradev/api-enums');

module.exports = req => {
  const session = {
    ip: req.info.remoteAddress || '',
    forwardedFor: req.headers['x-forwarded-for'] || '',
    agent: req.headers['user-agent'] || '',
    user: {
      id: '',
      name: '',
      email: '',
      profile: '',
      status: userStatus.DISABLED,
      has_two_factor_enabled: false
    },
    company: {
      id: '',
      name: '',
      parentId: '',
      subAccountType: ''
    },
    application: {
      id: ''
    }
  };

  if (session.forwardedFor) {
    session.ip = session.forwardedFor.split(',')[0].trim();
  }

  if (req.auth.credentials) {
    let user = Object.assign({}, req.auth.credentials);
    session.user = {
      id: user.id || '',
      name: user.name || '',
      email: user.email || '',
      profile: user.profile || '',
      status: user.status || userStatus.DISABLED,
      has_two_factor_enabled: !!user.has_two_factor_enabled
    };
    if (user.application) {
      session.application = {
        id: user.application.id || ''
      };
    }
    if (user.company) {
      session.company = {
        id: user.company.id || '',
        name: user.company.name || '',
        parentId: user.company.parentId || '',
        subAccountType: user.company.subAccountType || ''
      };
    }
    if (session.user.id || session.company.id || session.application.id) {
      return session;
    }
  }

  if (req.headers['x-session']) {
    const headerData = JSON.parse(req.headers['x-session']);
    session.ip = headerData.ip || session.ip;
    session.agent = headerData.agent || session.agent;
    session.user = Object.assign(session.user, headerData.user || {});
    session.company = Object.assign(session.company, headerData.company || {});
    session.application = Object.assign(session.application, headerData.application || {});
  }

  return session;
};
